module.exports = __webpack_public_path__ + "static/media/vid_dd.d0a69bb5.mp4";